// import React, { useState } from "react";
// import axios from "axios";

// const DepartmentForm = () => {
//   const [formData, setFormData] = useState({
//     vision: "",
//     mission: "",
//     about: "",
//     hodDetails: { name: "", talk: "" },
//     facultyDetails: [],
//     NonFaculty: [],
//   });

//   const [departmentPhoto, setDepartmentPhoto] = useState(null);
//   const [hodPhoto, setHodPhoto] = useState(null);
//   const [facultyPhotos, setFacultyPhotos] = useState([]);
//   const [nonFacultyPhotos, setNonFacultyPhotos] = useState([]);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleHodChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       hodDetails: { ...prev.hodDetails, [name]: value },
//     }));
//   };

//   const handleAddFaculty = () => {
//     setFormData((prev) => ({
//       ...prev,
//       facultyDetails: [...prev.facultyDetails, { name: "", designation: "", qualification: "", interests: "" }],
//     }));
//   };

//   const handleAddNonFaculty = () => {
//     setFormData((prev) => ({
//       ...prev,
//       NonFaculty: [...prev.NonFaculty, { name: "", designation: "", qualification: "", interests: "" }],
//     }));
//   };

//   const handleFacultyChange = (index, field, value) => {
//     const updatedFaculty = [...formData.facultyDetails];
//     updatedFaculty[index][field] = value;
//     setFormData((prev) => ({ ...prev, facultyDetails: updatedFaculty }));
//   };

//   const handleNonFacultyChange = (index, field, value) => {
//     const updatedNonFaculty = [...formData.NonFaculty];
//     updatedNonFaculty[index][field] = value;
//     setFormData((prev) => ({ ...prev, NonFaculty: updatedNonFaculty }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const data = new FormData();
//     data.append("vision", formData.vision);
//     data.append("mission", formData.mission);
//     data.append("about", formData.about);
//     if (departmentPhoto) data.append("departmentPhoto", departmentPhoto);
//     if (hodPhoto) data.append("hodPhoto", hodPhoto);
//     data.append("hodDetails", JSON.stringify(formData.hodDetails));
//     data.append("facultyDetails", JSON.stringify(formData.facultyDetails));
//     data.append("NonFaculty", JSON.stringify(formData.NonFaculty));

//     facultyPhotos.forEach((photo, index) => {
//       data.append(facultyPhotos, photo);
//     });

//     nonFacultyPhotos.forEach((photo, index) => {
//       data.append(nonFacultyPhotos, photo);
//     });

//     try {
//       const response = await axios.post("http://localhost:5000/api/saveDepartment", data, {
//         headers: {
//           "Content-Type": "multipart/form-data",
//         },
//       });
//       alert(response.data.message);
//     } catch (err) {
//       console.error("Error submitting form:", err);
//       alert("Failed to submit data.");
//     }
//   };

//   return (
//     <form onSubmit={handleSubmit}>
//       <h2>Department Form</h2>
//       <label>Vision: <input type="text" name="vision" value={formData.vision} onChange={handleInputChange} /></label>
//       <label>Mission: <input type="text" name="mission" value={formData.mission} onChange={handleInputChange} /></label>
//       <label>About: <textarea name="about" value={formData.about} onChange={handleInputChange}></textarea></label>
//       <label>Department Photo: <input type="file" onChange={(e) => setDepartmentPhoto(e.target.files[0])} /></label>
//       <h3>HOD Details</h3>
//       <label>Name: <input type="text" name="name" value={formData.hodDetails.name} onChange={handleHodChange} /></label>
//       <label>Talk: <textarea name="talk" value={formData.hodDetails.talk} onChange={handleHodChange}></textarea></label>
//       <label>HOD Photo: <input type="file" onChange={(e) => setHodPhoto(e.target.files[0])} /></label>
//       <h3>Faculty Details</h3>
//       {formData.facultyDetails.map((faculty, index) => (
//         <div key={index}>
//           <label>Name: <input type="text" value={faculty.name} onChange={(e) => handleFacultyChange(index, "name", e.target.value)} /></label>
//           <label>Designation: <input type="text" value={faculty.designation} onChange={(e) => handleFacultyChange(index, "designation", e.target.value)} /></label>
//           <label>Qualification: <input type="text" value={faculty.qualification} onChange={(e) => handleFacultyChange(index, "qualification", e.target.value)} /></label>
//           <label>Interests: <input type="text" value={faculty.interests} onChange={(e) => handleFacultyChange(index, "interests", e.target.value)} /></label>
//           <label>Photo: <input type="file" onChange={(e) => {
//             const updatedPhotos = [...facultyPhotos];
//             updatedPhotos[index] = e.target.files[0];
//             setFacultyPhotos(updatedPhotos);
//           }} /></label>
//         </div>
//       ))}
//       <button type="button" onClick={handleAddFaculty}>Add Faculty</button>
//       <h3>Non-Faculty Details</h3>
//       {formData.NonFaculty.map((nonFaculty, index) => (
//         <div key={index}>
//           <label>Name: <input type="text" value={nonFaculty.name} onChange={(e) => handleNonFacultyChange(index, "name", e.target.value)} /></label>
//           <label>Designation: <input type="text" value={nonFaculty.designation} onChange={(e) => handleNonFacultyChange(index, "designation", e.target.value)} /></label>
//           <label>Qualification: <input type="text" value={nonFaculty.qualification} onChange={(e) => handleNonFacultyChange(index, "qualification", e.target.value)} /></label>
//           <label>Interests: <input type="text" value={nonFaculty.interests} onChange={(e) => handleNonFacultyChange(index, "interests", e.target.value)} /></label>
//           <label>Photo: <input type="file" onChange={(e) => {
//             const updatedPhotos = [...nonFacultyPhotos];
//             updatedPhotos[index] = e.target.files[0];
//             setNonFacultyPhotos(updatedPhotos);
//           }} /></label>
//         </div>
//       ))}
//       <button type="button" onClick={handleAddNonFaculty}>Add Non-Faculty</button>
//       <button type="submit">Submit</button>
//     </form>
//   );
// };

// export default DepartmentForm;
import React, { useEffect, useState } from 'react';
import axios from 'axios';

const AdminPanel = () => {
    const [department, setDepartment] = useState('basic_science');
    const [data, setData] = useState(null);
    const [vision, setVision] = useState('');
    const [mission, setMission] = useState('');
    const [about, setAbout] = useState('');
    const [departmentPhoto, setDepartmentPhoto] = useState('');
    const [hodName, setHodName] = useState('');
    const [hodTalk, setHodTalk] = useState('');
    const [hodPhoto, setHodPhoto] = useState('');
    const [faculty, setFaculty] = useState([{ name: '', designation: '', qualification: '', interests: '', photo: '' }]);
    const [nonFaculty, setNonFaculty] = useState([{ name: '', photo: '' }]);

    useEffect(() => {
      axios.post('/api/data', { department })
          .then(res => {
              console.log('Fetched data:', res.data);  // Log data
              setData(res.data);
              if (res.data.visionMission) {
                  setVision(res.data.visionMission.vision);
                  setMission(res.data.visionMission.mission);
                  setAbout(res.data.visionMission.about);
                  setDepartmentPhoto(res.data.visionMission.departmentPhoto);
              }
              if (res.data.hod) {
                  setHodName(res.data.hod.name);
                  setHodTalk(res.data.hod.talk);
                  setHodPhoto(res.data.hod.photo);
              }
              if (res.data.faculty) {
                  setFaculty(res.data.faculty);
              }
              if (res.data.nonFaculty) {
                  setNonFaculty(res.data.nonFaculty);
              }
          })
          .catch(err => {
              console.error('Error fetching data:', err);
          });
  }, [department]);
  
    const handleHodUpdate = (e) => {
        e.preventDefault();
        axios.post('/api/update-hod', {
            department,
            name: hodName,
            talk: hodTalk,
            photo: hodPhoto,
        })
        .then(res => console.log('Updated HOD:', res.data))
        .catch(err => console.error(err));
    };

    const handleVisionMissionUpdate = (e) => {
        e.preventDefault();
        axios.post('/api/update-vision-mission', {
            department,
            vision,
            mission,
            about,
            departmentPhoto,
        })
        .then(res => console.log('Updated Vision & Mission:', res.data))
        .catch(err => console.error(err));
    };

    const handleAddFaculty = (index) => {
        const newFaculty = [...faculty];
        newFaculty.push({ name: '', designation: '', qualification: '', interests: '', photo: '' });
        setFaculty(newFaculty);
    };

    const handleFacultyChange = (index, e) => {
        const updatedFaculty = [...faculty];
        updatedFaculty[index][e.target.name] = e.target.value;
        setFaculty(updatedFaculty);
    };

    const handleRemoveFaculty = (index) => {
        const updatedFaculty = faculty.filter((_, i) => i !== index);
        setFaculty(updatedFaculty);
    };

    const handleAddNonFaculty = () => {
        setNonFaculty([...nonFaculty, { name: '', photo: '' }]);
    };

    const handleNonFacultyChange = (index, e) => {
        const updatedNonFaculty = [...nonFaculty];
        updatedNonFaculty[index][e.target.name] = e.target.value;
        setNonFaculty(updatedNonFaculty);
    };

    return (
        <div>
            <h1>Admin Panel</h1>
            <select value={department} onChange={(e) => setDepartment(e.target.value)}>
                <option value="basic_science">Basic Science</option>
                <option value="computer_science">Computer Science</option>
                <option value="electronics">Electronics</option>
            </select>

            {data && (
                <div>
                    {/* Vision & Mission Form */}
                    <h2>Vision & Mission</h2>
                    <form onSubmit={handleVisionMissionUpdate}>
                        <input
                            type="text"
                            placeholder="Vision"
                            value={vision}
                            onChange={(e) => setVision(e.target.value)}
                        />
                        <textarea
                            placeholder="Mission"
                            value={mission}
                            onChange={(e) => setMission(e.target.value)}
                        ></textarea>
                        <textarea
                            placeholder="About Department"
                            value={about}
                            onChange={(e) => setAbout(e.target.value)}
                        ></textarea>
                        <input
                            type="file"
                            onChange={(e) => setDepartmentPhoto(e.target.files[0])}
                        />
                        <button type="submit">Save Vision & Mission</button>
                    </form>

                    {/* HOD Details Form */}
                    <h2>HOD Details</h2>
                    <form onSubmit={handleHodUpdate}>
                        <input
                            type="text"
                            placeholder="Name"
                            value={hodName}
                            onChange={(e) => setHodName(e.target.value)}
                        />
                        <textarea
                            placeholder="Talk"
                            value={hodTalk}
                            onChange={(e) => setHodTalk(e.target.value)}
                        ></textarea>
                        <input
                            type="file"
                            onChange={(e) => setHodPhoto(e.target.files[0])}
                        />
                        <button type="submit">Save HOD</button>
                    </form>

                    {/* Faculty Form */}
                    <h2>Faculty Details</h2>
                    {faculty.map((member, index) => (
                        <div key={index}>
                            <input
                                type="text"
                                placeholder="Faculty Name"
                                value={member.name}
                                name="name"
                                onChange={(e) => handleFacultyChange(index, e)}
                            />
                            <input
                                type="text"
                                placeholder="Designation"
                                value={member.designation}
                                name="designation"
                                onChange={(e) => handleFacultyChange(index, e)}
                            />
                            <input
                                type="text"
                                placeholder="Qualification"
                                value={member.qualification}
                                name="qualification"
                                onChange={(e) => handleFacultyChange(index, e)}
                            />
                            <input
                                type="text"
                                placeholder="Interests"
                                value={member.interests}
                                name="interests"
                                onChange={(e) => handleFacultyChange(index, e)}
                            />
                            <input
                                type="file"
                                name="photo"
                                onChange={(e) => handleFacultyChange(index, e)}
                            />
                            <button type="button" onClick={() => handleRemoveFaculty(index)}>Remove</button>
                        </div>
                    ))}
                    <button type="button" onClick={handleAddFaculty}>Add Faculty</button>

                    {/* Non-Faculty Form */}
                    <h2>Non-Faculty Details</h2>
                    {nonFaculty.map((member, index) => (
                        <div key={index}>
                            <input
                                type="text"
                                placeholder="Non-Faculty Name"
                                value={member.name}
                                name="name"
                                onChange={(e) => handleNonFacultyChange(index, e)}
                            />
                            <input
                                type="file"
                                name="photo"
                                onChange={(e) => handleNonFacultyChange(index, e)}
                            />
                        </div>
                    ))}
                    <button type="button" onClick={handleAddNonFaculty}>Add Non-Faculty</button>
                </div>
            )}
        </div>
    );
};

export default AdminPanel;
